// //Emergent code 
// //import React, { useEffect, useState, useCallback } from "react";
// // import { useNavigate, useSearchParams } from "react-router-dom";
// // import AppLayout from "@/components/AppLayout";
// // import api from "@/lib/api";
// // import { Card } from "@/components/ui/card";
// // import { Button } from "@/components/ui/button";
// // import { Textarea } from "@/components/ui/textarea";
// // import { Label } from "@/components/ui/label";
// // import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
// // import StatusBadge from "@/components/shared/StatusBadge";
// // import ContactUnlock from "@/components/shared/ContactUnlock";
// // import EmptyState from "@/components/shared/EmptyState";
// // import Rating from "@/components/shared/Rating";
// // import { inr } from "@/lib/format";
// // import { toast } from "sonner";

// // export default function Applications() {
// //   const [sp, setSp] = useSearchParams();
// //   const nav = useNavigate();
// //   const role = sp.get("role") || "applicant";
// //   const [apps, setApps] = useState([]);
// //   const [reviewedIds, setReviewedIds] = useState(new Set());
// //   const [reviewOpen, setReviewOpen] = useState(null);
// //   const [rating, setRating] = useState(5);
// //   const [text, setText] = useState("");

// //   const load = useCallback(async () => {
// //     const [{ data }, { data: mine }] = await Promise.all([
// //       api.get("/applications", { params: { role } }),
// //       api.get("/reviews/mine").catch(() => ({ data: { written_application_ids: [] } })),
// //     ]);
// //     setApps(data);
// //     setReviewedIds(new Set(mine.written_application_ids || []));
// //   }, [role]);

// //   useEffect(() => { load(); }, [load]);

// //   const updateStatus = async (id, status) => {
// //     try {
// //       await api.patch(`/applications/${id}`, { status });
// //       toast.success(`Application ${status}`);
// //       load();
// //     } catch (e) {
// //       toast.error(e?.response?.data?.detail || "Failed");
// //     }
// //   };

// //   const submitReview = async () => {
// //     if (!reviewOpen) return;
// //     if (!text.trim()) { toast.error("Please write a short review"); return; }
// //     try {
// //       await api.post("/reviews", {
// //         application_id: reviewOpen.application_id, rating, written_review: text,
// //       });
// //       toast.success("Review submitted");
// //       setReviewOpen(null); setText(""); setRating(5);
// //       load();
// //     } catch (e) {
// //       toast.error(e?.response?.data?.detail || "Failed");
// //     }
// //   };

// //   return (
// //     <AppLayout>
// //       <div className="flex items-center justify-between flex-wrap gap-3">
// //         <h1 className="font-display text-3xl font-bold tracking-tight">Applications</h1>
// //         <div className="flex gap-2">
// //           <button data-testid="tab-mine"
// //             onClick={() => setSp({ role: "applicant" })}
// //             className={`px-4 py-2 text-sm rounded-lg ${role === "applicant" ? "bg-slate-900 text-white" : "bg-white border border-slate-200"}`}>
// //             My Applications
// //           </button>
// //           <button data-testid="tab-received"
// //             onClick={() => setSp({ role: "poster" })}
// //             className={`px-4 py-2 text-sm rounded-lg ${role === "poster" ? "bg-slate-900 text-white" : "bg-white border border-slate-200"}`}>
// //             Received Applications
// //           </button>
// //         </div>
// //       </div>

// //       <div className="mt-6 space-y-4">
// //         {apps.length === 0 && (
// //           <EmptyState
// //             title={role === "poster" ? "No applications received yet" : "No applications yet"}
// //             description={role === "poster" ? "Post a gig to start receiving applications." : "Explore gigs and apply to the ones that match you."}
// //             action={<Button onClick={() => nav("/explore?category=gigs")} className="bg-[#4F46E5] hover:bg-[#4338CA] text-white">Explore gigs</Button>}
// //           />
// //         )}
// //         {apps.map((a) => {
// //           const alreadyReviewed = reviewedIds.has(a.application_id);
// //           return (
// //             <Card key={a.application_id} className="p-5 border-slate-200" data-testid={`app-${a.application_id}`}>
// //               <div className="grid grid-cols-1 md:grid-cols-[1fr_280px] gap-6">
// //                 <div>
// //                   <div className="flex items-center gap-2 mb-2">
// //                     <StatusBadge status={a.status} testId={`app-status-badge-${a.application_id}`} />
// //                     <span className="text-xs text-slate-500">{new Date(a.created_at).toLocaleDateString()}</span>
// //                   </div>
// //                   <div className="font-semibold">{a.opportunity_title}</div>
// //                   <div className="text-sm text-slate-600 mt-1">
// //                     {role === "poster" ? (
// //                       <span className="inline-flex items-center gap-2">
// //                         {a.applicant_picture_url && <img src={a.applicant_picture_url} alt="" className="w-6 h-6 rounded-full object-cover" />}
// //                         From <b>{a.applicant_name}</b>
// //                       </span>
// //                     ) : (
// //                       <>Posted by <b>{a.poster_name}</b></>
// //                     )}
// //                   </div>
// //                   <p className="mt-3 text-sm text-slate-700">{a.message}</p>
// //                   {a.proposed_rate && <div className="mt-2 text-sm">Proposed rate: <b>{inr(a.proposed_rate)}</b></div>}
// //                   {role === "poster" && a.status === "pending" && (
// //                     <div className="mt-4 flex gap-2">
// //                       <Button size="sm" onClick={() => updateStatus(a.application_id, "accepted")}
// //                         data-testid={`accept-${a.application_id}`}
// //                         className="bg-emerald-600 hover:bg-emerald-700 text-white">Accept</Button>
// //                       <Button size="sm" variant="outline" onClick={() => updateStatus(a.application_id, "rejected")}
// //                         data-testid={`reject-${a.application_id}`}>Reject</Button>
// //                     </div>
// //                   )}
// //                   {a.status === "accepted" && (
// //                     <div className="mt-4">
// //                       <Button size="sm" variant="outline"
// //                         onClick={() => updateStatus(a.application_id, "completed")}
// //                         data-testid={`complete-${a.application_id}`}>
// //                         Mark completed
// //                       </Button>
// //                     </div>
// //                   )}
// //                   {a.status === "completed" && (
// //                     <div className="mt-4">
// //                       {alreadyReviewed ? (
// //                         <span className="text-sm text-slate-500">You've already reviewed this deal.</span>
// //                       ) : (
// //                         <Button size="sm" onClick={() => { setReviewOpen(a); setRating(5); setText(""); }}
// //                           data-testid={`review-${a.application_id}`}
// //                           className="bg-[#4F46E5] hover:bg-[#4338CA] text-white">
// //                           Leave a review
// //                         </Button>
// //                       )}
// //                     </div>
// //                   )}
// //                 </div>
// //                 <div>
// //                   <ContactUnlock applicationId={a.application_id} status={a.status} />
// //                 </div>
// //               </div>
// //             </Card>
// //           );
// //         })}
// //       </div>

// //       <Dialog open={!!reviewOpen} onOpenChange={(v) => !v && setReviewOpen(null)}>
// //         <DialogContent>
// //           <DialogHeader>
// //             <DialogTitle>Leave a review</DialogTitle>
// //           </DialogHeader>
// //           <div className="space-y-3">
// //             <div>
// //               <Label>Rating</Label>
// //               <div className="mt-2">
// //                 <Rating value={rating} onChange={setRating} size={28} showValue={false} testId="review-rating" />
// //               </div>
// //             </div>
// //             <div>
// //               <Label>Your review</Label>
// //               <Textarea rows={4} value={text} onChange={(e) => setText(e.target.value)}
// //                 data-testid="review-text"
// //                 placeholder="How was working with them? Punctuality, professionalism, quality…" />
// //             </div>
// //           </div>
// //           <DialogFooter>
// //             <Button variant="outline" onClick={() => setReviewOpen(null)}>Cancel</Button>
// //             <Button onClick={submitReview} data-testid="review-submit"
// //               className="bg-[#4F46E5] hover:bg-[#4338CA] text-white">Submit review</Button>
// //           </DialogFooter>
// //         </DialogContent>
// //       </Dialog>
// //     </AppLayout>
// //   );
// // }

// // Updated code by kushal
// import React, { useEffect, useState, useCallback } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import AppLayout from "@/components/AppLayout";
// import api from "@/lib/api";
// import { Card } from "@/components/ui/card";
// import { Button } from "@/components/ui/button";
// import { Textarea } from "@/components/ui/textarea";
// import { Label } from "@/components/ui/label";
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogFooter,
//   DialogDescription,
// } from "@/components/ui/dialog";
// import StatusBadge from "@/components/shared/StatusBadge";
// import ContactUnlock from "@/components/shared/ContactUnlock";
// import EmptyState from "@/components/shared/EmptyState";
// import Rating from "@/components/shared/Rating";
// import { inr } from "@/lib/format";
// import { toast } from "sonner";

// export default function Applications() {
//   const [sp, setSp] = useSearchParams();
//   const nav = useNavigate();

//   const role = sp.get("role") || "applicant";
//   const gigFilter =
//     sp.get("gig_filter") || (role === "poster" ? "open" : "all");

//   const [apps, setApps] = useState([]);
//   const [reviewedIds, setReviewedIds] = useState(new Set());

//   const [reviewOpen, setReviewOpen] = useState(null);
//   const [rating, setRating] = useState(5);
//   const [text, setText] = useState("");

//   // Application acceptance confirmation
//   const [acceptOpen, setAcceptOpen] = useState(null);
//   const [accepting, setAccepting] = useState(false);

//   const load = useCallback(async () => {
//     try {
//       const [{ data }, { data: mine }] = await Promise.all([
//         api.get("/applications", {
//           params: {
//             role,
//             gig_filter: role === "poster" ? gigFilter : "all",
//           },
//         }),
//         api
//           .get("/reviews/mine")
//           .catch(() => ({ data: { written_application_ids: [] } })),
//       ]);

//       setApps(data);
//       setReviewedIds(new Set(mine.written_application_ids || []));
//     } catch (e) {
//       toast.error(
//         e?.response?.data?.detail || "Failed to load applications"
//       );
//     }
//   }, [role, gigFilter]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const openAcceptConfirmation = (application) => {
//     setAcceptOpen(application);
//   };

//   const confirmAccept = async () => {
//     if (!acceptOpen || accepting) return;

//     setAccepting(true);

//     try {
//       // First accept the application.
//       await api.patch(`/applications/${acceptOpen.application_id}`, {
//         status: "accepted",
//       });

//       // Then explicitly unlock contact information.
//       await api.post(
//         `/applications/${acceptOpen.application_id}/contact/unlock`
//       );

//       toast.success("Application accepted and contact information revealed");

//       setAcceptOpen(null);
//       await load();
//     } catch (e) {
//       toast.error(
//         e?.response?.data?.detail || "Failed to accept the application"
//       );
//     } finally {
//       setAccepting(false);
//     }
//   };

//   const updateStatus = async (id, status) => {
//     try {
//       await api.patch(`/applications/${id}`, { status });
//       toast.success(`Application ${status}`);
//       await load();
//     } catch (e) {
//       toast.error(e?.response?.data?.detail || "Failed");
//     }
//   };

//   const submitReview = async () => {
//     if (!reviewOpen) return;

//     if (!text.trim()) {
//       toast.error("Please write a short review");
//       return;
//     }

//     try {
//       await api.post("/reviews", {
//         application_id: reviewOpen.application_id,
//         rating,
//         written_review: text,
//       });

//       toast.success("Review submitted");
//       setReviewOpen(null);
//       setText("");
//       setRating(5);
//       await load();
//     } catch (e) {
//       toast.error(e?.response?.data?.detail || "Failed");
//     }
//   };

//   return (
//     <AppLayout>
//       <div className="flex items-center justify-between flex-wrap gap-3">
//         <h1 className="font-display text-3xl font-bold tracking-tight">
//           Applications
//         </h1>

//         <div className="flex gap-2 flex-wrap">
//           <button
//             data-testid="tab-mine"
//             onClick={() => setSp({ role: "applicant" })}
//             className={`px-4 py-2 text-sm rounded-lg ${
//               role === "applicant"
//                 ? "bg-slate-900 text-white"
//                 : "bg-white border border-slate-200"
//             }`}
//           >
//             My Applications
//           </button>

//           <button
//             data-testid="tab-received"
//             onClick={() => setSp({ role: "poster", gig_filter: "open" })}
//             className={`px-4 py-2 text-sm rounded-lg ${
//               role === "poster"
//                 ? "bg-slate-900 text-white"
//                 : "bg-white border border-slate-200"
//             }`}
//           >
//             Received Applications
//           </button>

//           {role === "poster" && (
//             <select
//               value={gigFilter}
//               onChange={(e) => {
//                 setSp({
//                   role: "poster",
//                   gig_filter: e.target.value,
//                 });
//               }}
//               data-testid="received-gig-filter"
//               className="px-4 py-2 text-sm rounded-lg bg-white border border-slate-200 text-slate-700"
//             >
//               <option value="open">Open</option>
//               <option value="closed">Closed</option>
//               <option value="all">All</option>
//             </select>
//           )}
//         </div>
//       </div>

//       <div className="mt-6 space-y-4">
//         {apps.length === 0 && (
//           <EmptyState
//             title={
//               role === "poster"
//                 ? gigFilter === "open"
//                   ? "No applications for open gigs"
//                   : gigFilter === "closed"
//                   ? "No applications for closed gigs"
//                   : "No applications received yet"
//                 : "No applications yet"
//             }
//             description={
//               role === "poster"
//                 ? gigFilter === "open"
//                   ? "Applications for your currently open gigs will appear here."
//                   : gigFilter === "closed"
//                   ? "Applications for closed gigs will appear here."
//                   : "Post a gig to start receiving applications."
//                 : "Explore gigs and apply to the ones that match you."
//             }
//             action={
//               role === "applicant" ? (
//                 <Button
//                   onClick={() => nav("/explore?category=gigs")}
//                   className="bg-[#4F46E5] hover:bg-[#4338CA] text-white"
//                 >
//                   Explore gigs
//                 </Button>
//               ) : null
//             }
//           />
//         )}

//         {apps.map((a) => {
//           const alreadyReviewed = reviewedIds.has(a.application_id);

//           return (
//             <Card
//               key={a.application_id}
//               className="p-5 border-slate-200"
//               data-testid={`app-${a.application_id}`}
//             >
//               <div className="grid grid-cols-1 md:grid-cols-[1fr_280px] gap-6">
//                 <div>
//                   <div className="flex items-center gap-2 mb-2">
//                     <StatusBadge
//                       status={a.status}
//                       testId={`app-status-badge-${a.application_id}`}
//                     />

//                     <span className="text-xs text-slate-500">
//                       {new Date(a.created_at).toLocaleDateString()}
//                     </span>
//                   </div>

//                   <div className="font-semibold">
//                     {a.opportunity_title}
//                   </div>

//                   <div className="text-sm text-slate-600 mt-1">
//                     {role === "poster" ? (
//                       <span className="inline-flex items-center gap-2">
//                         {a.applicant_picture_url && (
//                           <img
//                             src={a.applicant_picture_url}
//                             alt=""
//                             className="w-6 h-6 rounded-full object-cover"
//                           />
//                         )}
//                         From <b>{a.applicant_name}</b>
//                       </span>
//                     ) : (
//                       <>
//                         Posted by <b>{a.poster_name}</b>
//                       </>
//                     )}
//                   </div>

//                   <p className="mt-3 text-sm text-slate-700">
//                     {a.message}
//                   </p>

//                   {a.proposed_rate && (
//                     <div className="mt-2 text-sm">
//                       Proposed rate: <b>{inr(a.proposed_rate)}</b>
//                     </div>
//                   )}

//                   {/* Pending application: poster can accept/reject */}
//                   {role === "poster" && a.status === "pending" && (
//                     <div className="mt-4 flex gap-2">
//                       <Button
//                         size="sm"
//                         onClick={() => openAcceptConfirmation(a)}
//                         data-testid={`accept-${a.application_id}`}
//                         className="bg-emerald-600 hover:bg-emerald-700 text-white"
//                       >
//                         Accept
//                       </Button>

//                       <Button
//                         size="sm"
//                         variant="outline"
//                         onClick={() =>
//                           updateStatus(a.application_id, "rejected")
//                         }
//                         data-testid={`reject-${a.application_id}`}
//                       >
//                         Reject
//                       </Button>
//                     </div>
//                   )}

//                   {/* Accepted application */}
//                   {a.status === "accepted" && (
//                     <div className="mt-4">
//                       <Button
//                         size="sm"
//                         variant="outline"
//                         onClick={() =>
//                           updateStatus(a.application_id, "completed")
//                         }
//                         data-testid={`complete-${a.application_id}`}
//                       >
//                         Mark completed
//                       </Button>
//                     </div>
//                   )}

//                   {/* Completed application */}
//                   {a.status === "completed" && (
//                     <div className="mt-4">
//                       {alreadyReviewed ? (
//                         <span className="text-sm text-slate-500">
//                           You've already reviewed this deal.
//                         </span>
//                       ) : (
//                         <Button
//                           size="sm"
//                           onClick={() => {
//                             setReviewOpen(a);
//                             setRating(5);
//                             setText("");
//                           }}
//                           data-testid={`review-${a.application_id}`}
//                           className="bg-[#4F46E5] hover:bg-[#4338CA] text-white"
//                         >
//                           Leave a review
//                         </Button>
//                       )}
//                     </div>
//                   )}
//                 </div>

//                 <div>
//                   <ContactUnlock
//                     applicationId={a.application_id}
//                     status={a.status}
//                     contactUnlocked={a.contact_unlocked === true}
//                     isPoster={role === "poster"}
//                   />
//                 </div>
//               </div>
//             </Card>
//           );
//         })}
//       </div>

//       {/* Accept confirmation dialog */}
//       <Dialog
//         open={!!acceptOpen}
//         onOpenChange={(open) => {
//           if (!open && !accepting) {
//             setAcceptOpen(null);
//           }
//         }}
//       >
//         <DialogContent>
//           <DialogHeader>
//             <DialogTitle>Accept this application?</DialogTitle>

//             <DialogDescription>
//               Accepting this application will confirm{" "}
//               <b>{acceptOpen?.applicant_name}</b> for the gig and reveal the
//               contact information for both parties.
//             </DialogDescription>
//           </DialogHeader>

//           <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 p-4">
//             <p className="text-sm text-amber-900">
//               Contact information will only be revealed after you confirm
//               below.
//             </p>
//           </div>

//           <DialogFooter>
//             <Button
//               variant="outline"
//               onClick={() => setAcceptOpen(null)}
//               disabled={accepting}
//             >
//               Cancel
//             </Button>

//             <Button
//               onClick={confirmAccept}
//               disabled={accepting}
//               data-testid={
//                 acceptOpen
//                   ? `confirm-accept-${acceptOpen.application_id}`
//                   : "confirm-accept"
//               }
//               className="bg-emerald-600 hover:bg-emerald-700 text-white"
//             >
//               {accepting ? "Accepting…" : "Accept & Reveal Contact"}
//             </Button>
//           </DialogFooter>
//         </DialogContent>
//       </Dialog>

//       {/* Review dialog */}
//       <Dialog
//         open={!!reviewOpen}
//         onOpenChange={(v) => !v && setReviewOpen(null)}
//       >
//         <DialogContent>
//           <DialogHeader>
//             <DialogTitle>Leave a review</DialogTitle>
//           </DialogHeader>

//           <div className="space-y-3">
//             <div>
//               <Label>Rating</Label>

//               <div className="mt-2">
//                 <Rating
//                   value={rating}
//                   onChange={setRating}
//                   size={28}
//                   showValue={false}
//                   testId="review-rating"
//                 />
//               </div>
//             </div>

//             <div>
//               <Label>Your review</Label>

//               <Textarea
//                 rows={4}
//                 value={text}
//                 onChange={(e) => setText(e.target.value)}
//                 data-testid="review-text"
//                 placeholder="How was working with them? Punctuality, professionalism, quality…"
//               />
//             </div>
//           </div>

//           <DialogFooter>
//             <Button
//               variant="outline"
//               onClick={() => setReviewOpen(null)}
//             >
//               Cancel
//             </Button>

//             <Button
//               onClick={submitReview}
//               data-testid="review-submit"
//               className="bg-[#4F46E5] hover:bg-[#4338CA] text-white"
//             >
//               Submit review
//             </Button>
//           </DialogFooter>
//         </DialogContent>
//       </Dialog>
//     </AppLayout>
//   );
// }






import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import StatusBadge from "@/components/shared/StatusBadge";
import ContactUnlock from "@/components/shared/ContactUnlock";
import EmptyState from "@/components/shared/EmptyState";
import Rating from "@/components/shared/Rating";
import { inr } from "@/lib/format";
import { toast } from "sonner";

export default function Applications() {
  const [sp, setSp] = useSearchParams();
  const nav = useNavigate();
  const role = sp.get("role") || "applicant";
  const gigFilter = sp.get("gig_filter") || (role === "poster" ? "open" : "all");
  const [apps, setApps] = useState([]);
  const [reviewedIds, setReviewedIds] = useState(new Set());
  const [reviewOpen, setReviewOpen] = useState(null);
  const [rating, setRating] = useState(5);
  const [text, setText] = useState("");
  const [acceptOpen, setAcceptOpen] = useState(null);
  const [accepting, setAccepting] = useState(false);

  const load = useCallback(async () => {
    try {
      const [{ data }, { data: mine }] = await Promise.all([
        api.get("/applications", { params: { role, gig_filter: role === "poster" ? gigFilter : "all" } }),
        api.get("/reviews/mine").catch(() => ({ data: { written_application_ids: [] } })),
      ]);
      setApps(data || []);
      setReviewedIds(new Set(mine.written_application_ids || []));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to load applications");
    }
  }, [role, gigFilter]);

  useEffect(() => { load(); }, [load]);

  const openAcceptConfirmation = (application) => setAcceptOpen(application);

  const confirmAccept = async () => {
    if (!acceptOpen || accepting) return;
    setAccepting(true);
    try {
      await api.patch(`/applications/${acceptOpen.application_id}`, { status: "accepted" });
      await api.post(`/applications/${acceptOpen.application_id}/contact/unlock`);
      toast.success("Application accepted and contact information revealed");
      setAcceptOpen(null);
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to accept the application");
    } finally {
      setAccepting(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/applications/${id}`, { status });
      toast.success(`Application ${status}`);
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  const submitReview = async () => {
    if (!reviewOpen) return;
    if (!text.trim()) { toast.error("Please write a short review"); return; }
    try {
      await api.post("/reviews", { application_id: reviewOpen.application_id, rating, written_review: text });
      toast.success("Review submitted");
      setReviewOpen(null); setText(""); setRating(5); await load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <AppLayout>
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-display text-3xl font-bold tracking-tight">Applications</h1>
        <div className="flex gap-2 flex-wrap">
          <button data-testid="tab-mine" onClick={() => setSp({ role: "applicant" })}
            className={`px-4 py-2 text-sm rounded-lg ${role === "applicant" ? "bg-slate-900 text-white" : "bg-white border border-slate-200"}`}>
            My Applications
          </button>
          <button data-testid="tab-received" onClick={() => setSp({ role: "poster", gig_filter: "open" })}
            className={`px-4 py-2 text-sm rounded-lg ${role === "poster" ? "bg-slate-900 text-white" : "bg-white border border-slate-200"}`}>
            Received Applications
          </button>
          {role === "poster" && (
            <select value={gigFilter} onChange={(e) => setSp({ role: "poster", gig_filter: e.target.value })}
              data-testid="received-gig-filter"
              className="px-4 py-2 text-sm rounded-lg bg-white border border-slate-200 text-slate-700">
              <option value="open">Open</option>
              <option value="closed">Closed</option>
              <option value="all">All</option>
            </select>
          )}
        </div>
      </div>

      <div className="mt-6 space-y-4">
        {apps.length === 0 && (
          <EmptyState
            title={role === "poster" ? (gigFilter === "open" ? "No applications for open gigs" : gigFilter === "closed" ? "No applications for closed gigs" : "No applications received yet") : "No applications yet"}
            description={role === "poster" ? (gigFilter === "open" ? "Applications for your currently open gigs will appear here." : gigFilter === "closed" ? "Applications for closed gigs will appear here." : "Post a gig to start receiving applications.") : "Explore gigs and apply to the ones that match you."}
            action={role === "applicant" ? <Button onClick={() => nav("/explore?category=gigs")} className="bg-[#4F46E5] hover:bg-[#4338CA] text-white">Explore gigs</Button> : null}
          />
        )}

        {apps.map((a) => {
          const alreadyReviewed = reviewedIds.has(a.application_id);
          return (
            <Card key={a.application_id} className="p-5 border-slate-200" data-testid={`app-${a.application_id}`}>
              <div className="grid grid-cols-1 md:grid-cols-[1fr_280px] gap-6">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <StatusBadge status={a.status} testId={`app-status-badge-${a.application_id}`} />
                    <span className="text-xs text-slate-500">{new Date(a.created_at).toLocaleDateString()}</span>
                  </div>
                  <div className="font-semibold">{a.opportunity_title}</div>
                  <div className="text-sm text-slate-600 mt-1">
                    {role === "poster" ? (
                      <span className="inline-flex flex-wrap items-center gap-2">
                        {a.applicant_picture_url && <img src={a.applicant_picture_url} alt="" className="w-6 h-6 rounded-full object-cover" />}
                        From <b>{a.applicant_name}</b>
                        {a.applicant_profile_id && (
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => nav(`/profiles/view/${a.applicant_profile_id}`)}
                            data-testid={`view-applicant-profile-${a.application_id}`}
                          >
                            View profile
                          </Button>
                        )}
                      </span>
                    ) : <>Posted by <b>{a.poster_name}</b></>}
                  </div>
                  <p className="mt-3 text-sm text-slate-700">{a.message}</p>
                  {a.proposed_rate && <div className="mt-2 text-sm">Proposed rate: <b>{inr(a.proposed_rate)}</b></div>}
                  {role === "poster" && a.status === "pending" && (
                    <div className="mt-4 flex gap-2">
                      <Button size="sm" onClick={() => openAcceptConfirmation(a)} data-testid={`accept-${a.application_id}`} className="bg-emerald-600 hover:bg-emerald-700 text-white">Accept</Button>
                      <Button size="sm" variant="outline" onClick={() => updateStatus(a.application_id, "rejected")} data-testid={`reject-${a.application_id}`}>Reject</Button>
                    </div>
                  )}
                  {role === "poster" && a.status === "accepted" && (
                    <div className="mt-4"><Button size="sm" variant="outline" onClick={() => updateStatus(a.application_id, "completed")} data-testid={`complete-${a.application_id}`}>Mark completed</Button></div>
                  )}
                  {a.status === "completed" && (
                    <div className="mt-4">{alreadyReviewed ? <span className="text-sm text-slate-500">You've already reviewed this deal.</span> : <Button size="sm" onClick={() => { setReviewOpen(a); setRating(5); setText(""); }} data-testid={`review-${a.application_id}`} className="bg-[#4F46E5] hover:bg-[#4338CA] text-white">Leave a review</Button>}</div>
                  )}
                </div>
                <div><ContactUnlock applicationId={a.application_id} status={a.status} contactUnlocked={a.contact_unlocked === true} isPoster={role === "poster"} /></div>
              </div>
            </Card>
          );
        })}
      </div>

      <Dialog open={!!acceptOpen} onOpenChange={(open) => { if (!open && !accepting) setAcceptOpen(null); }}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Accept this application?</DialogTitle>
            <DialogDescription>Accepting this application will confirm <b>{acceptOpen?.applicant_name}</b> for the gig and reveal the contact information for both parties.</DialogDescription>
          </DialogHeader>
          <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 p-4"><p className="text-sm text-amber-900">Contact information will only be revealed after you confirm below.</p></div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setAcceptOpen(null)} disabled={accepting}>Cancel</Button>
            <Button onClick={confirmAccept} disabled={accepting} data-testid={acceptOpen ? `confirm-accept-${acceptOpen.application_id}` : "confirm-accept"} className="bg-emerald-600 hover:bg-emerald-700 text-white">{accepting ? "Accepting…" : "Accept & Reveal Contact"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={!!reviewOpen} onOpenChange={(v) => !v && setReviewOpen(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Leave a review</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Rating</Label><div className="mt-2"><Rating value={rating} onChange={setRating} size={28} showValue={false} testId="review-rating" /></div></div>
            <div><Label>Your review</Label><Textarea rows={4} value={text} onChange={(e) => setText(e.target.value)} data-testid="review-text" placeholder="How was working with them? Punctuality, professionalism, quality…" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setReviewOpen(null)}>Cancel</Button>
            <Button onClick={submitReview} data-testid="review-submit" className="bg-[#4F46E5] hover:bg-[#4338CA] text-white">Submit review</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </AppLayout>
  );
}
